import React, { useState } from "react";
import { Button } from "primereact/button";

const DataAndQuantityType = (props) => {
  const { buttonOptions, headerText, subTitle, headerSubTitle = "" } = props;

  // Handler to update active button
  const handleButtonClick = (option) => {
    props?.setActiveDataTypeButton(option.value);
  };

  return (
    <div className="d-flex justify-content-between mb-4">
      <div className="left-content">
        <h5 className="fw-bold text-start">{headerText}</h5>
        {/* <h6 className="fw-bold text-start my-1">{headerSubTitle}</h6> */}
        {subTitle !== "" ? (
          <p
            className="mb-0 text-start fw-bold fs-12 py-1"
            style={{ color: "#6c757d" }}
          >
            {subTitle}
          </p>
        ) : (
          ""
        )}
      </div>
      <div className="right-content">
        <div className="right-content d-flex flex-wrap justify-content-end">
          {buttonOptions.map((option, index) => (
            <Button
              key={index}
              className={`fs-14 p-1 fw-bold btn me-2 mb-1 ${
                props?.activeDataTypeButton === option.value
                  ? "active-button br-c"
                  : "light-bg br-c"
              }`}
              onClick={() => handleButtonClick(option)}
              label={option.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DataAndQuantityType;
